import React from 'react';
import ReactDOM from 'react-dom';
import $ from 'jquery';
import { Router, Route } from 'react-router-dom';
import { IntlProvider } from 'react-intl';
import { FluxibleComponent } from 'fluxible-addons-react';
import ddo from '@99designs/common/apps/ddo/index';
import models from 'apps/ddo/di';
import Fluxible from 'fluxible';
import OnlineStatusStore from 'stores/OnlineStatusStore';
import DesignDetailsSidebar from 'apps/ddo/components/DesignDetailsSidebar';
import history from 'utils/history';

document.addEventListener('DOMContentLoaded', () => {
    const appNode = document.getElementById('design-details-app');
    const dataNode = document.getElementById('ddo-app-data');
    const { initData } = JSON.parse(dataNode.textContent);
    const { activeUser, intlMessages, designCollection } = initData;
    const ddoPath = '/profiles/:parentId/designs/:designId';
    const csrfToken = document.querySelector('meta[name="csrf-token"]').getAttribute('content');
    const NoOpComponent = () => null;

    window.REQUEST_TOKENS = {
        DESIGN_COMMENT_CREATE_FINISH: csrfToken,
        DESIGN_COMMENT_DELETE_FINISH: csrfToken,
        DESIGN_COMMENT_UPDATE: csrfToken,
        DESIGN_UPDATE_LIKE_STATUS: csrfToken,
    };

    const fluxibleApp = new Fluxible({
        stores: [OnlineStatusStore],
    });

    const fluxibleContext = fluxibleApp.createContext();

    const { DdoComponent, setDesignCollection } = ddo({
        fluxibleApp,
        fluxibleContext,
        activeUser,
        designCollection: models.designCollection.fromJSON(designCollection),
        isInline: true,
        models,
        goBack: () => {
            history.go(-1);
        },
        goTo: path => {
            history.replace(path);
        },
        csrfToken: document.querySelector('meta[name=csrf-token]').getAttribute('content'),
    });

    window.addEventListener('newDdoDesignCollectionAvailable', e => {
        setDesignCollection(models.designCollection.fromJSON(e.detail));
    });

    $(document).on('click', '[data-design-details-item]', function(e) {
        if (e.metaKey || e.ctrlKey) {
            return true;
        }

        e.preventDefault();

        history.push($(this).attr('href'));
    });

    ReactDOM.render(
        <IntlProvider locale={document.documentElement.lang} messages={intlMessages}>
            <FluxibleComponent context={fluxibleContext.getComponentContext()}>
                <Router history={history}>
                    <div>
                        <Route
                            path={ddoPath}
                            component={props => (
                                <DdoComponent
                                    designId={props.match.params.designId}
                                    renderSidebar={sidebarProps => (
                                        <DesignDetailsSidebar
                                            activeUser={activeUser}
                                            {...sidebarProps}
                                        />
                                    )}
                                />
                            )}
                        />
                        <NoOpComponent path="*" />
                    </div>
                </Router>
            </FluxibleComponent>
        </IntlProvider>,
        appNode
    );
});



// WEBPACK FOOTER //
// ./src/js/page/inline-ddo.jsx